import { FEATURE_FLAG } from '~/constants';

import { type RouteExportParams } from '~/types/router.type';

import {
  deliveriesAllV2SearchDefaults,
  zodDeliveriesAllV2SearchSchema,
} from './-searchParams';

export const routeParams: RouteExportParams = {
  permissions: ['dln_in.'],
  featureFlag: FEATURE_FLAG.DLN_LIST_V2,
};

export const validateSearch = zodDeliveriesAllV2SearchSchema;
export const searchDefaults = deliveriesAllV2SearchDefaults;
